import { MUIGrid, MUIBox, MUITypography } from "@cobee/cobee-ui";
import { ReactComponent as EmptyImage } from "../../../assets/icons/empty.svg";
import styles from "./styles";

export default function EmptyBlock({
  title,
  subtitle,
}: {
  title: string;
  subtitle: string;
}): JSX.Element {
  const { textContainer, titleStyle, subtitleStyle } = styles;

  return (
    <MUIGrid container justifyContent="center" item xs={12}>
      <MUIBox sx={textContainer}>
        <MUITypography sx={titleStyle}>{title}</MUITypography>
        <MUITypography variant="body2" sx={subtitleStyle}>
          {subtitle}
        </MUITypography>
      </MUIBox>
      <EmptyImage />
    </MUIGrid>
  );
}
